import React from "react";
import ExportSearchForm from "./ExportsSearchForm";

const ExportsControlPanel = () => (
  <div id="sidebar" className="sidebar-search full-height alt-style">
    <div className="sidebar-search-container">
      <div className="sidebar-scroll-fade-top"></div>
      <div className="sidebar-search-wrapper">
        <div className="sidebar-search-content">
          <ExportSearchForm />
        </div>
      </div>
    </div>
  </div>
);

export default ExportsControlPanel;
